import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './UnsavedChangesPopover.css';

const UnsavedChangesPopover = ({
  isOpen,
  title = 'Подтверждение',
  message = 'У вас есть несохраненные изменения. Закрыть окно без сохранения?',
  onCancel,
  onConfirm,
  cancelText = 'Отмена',
  confirmText = 'Закрыть без сохранения',
  zIndex = 12000,
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const handleEscape = (e) => {
      if (e.key !== 'Escape') return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (typeof onCancel === 'function') onCancel();
    };
    document.addEventListener('keydown', handleEscape, { capture: true });
    return () => {
      document.removeEventListener('keydown', handleEscape, { capture: true });
    };
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  const content = (
    <div className="unsaved-changes-popover" style={{ zIndex }} role="dialog" aria-modal="false">
      <div className="unsaved-changes-popover__title">{title}</div>
      <div className="unsaved-changes-popover__message">{message}</div>
      <div className="unsaved-changes-popover__actions">
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          {cancelText}
        </button>
        <button type="button" className="btn btn-danger" onClick={onConfirm}>
          {confirmText}
        </button>
      </div>
    </div>
  );

  if (typeof document === 'undefined') return content;
  return createPortal(content, document.body);
};

export default UnsavedChangesPopover;
